import React from "react";
import AnswerScale from "../AnswerScale";
import PropTypes from "prop-types";

const AnswerScale10 = (props) => (
  <AnswerScale
    handleChange={props.handleChange}
    question={props.question}
    required={props.required}
    choices={[
      { value: "1", label: props.low },
      { value: "2" },
      { value: "3" },
      { value: "4" },
      { value: "5", label: props.middle },
      { value: "6" },
      { value: "7" },
      { value: "8" },
      { value: "9" },
      { value: "10", label: props.high },
    ]}
    value={props.value}
    endpointLow={props.low}
    endpointHigh={props.high}
    helperText={props.helperText}
    currentTheme={props.currentTheme}
  />
);

AnswerScale10.propTypes = {
  low: PropTypes.string,
  middle: PropTypes.string,
  high: PropTypes.string,
  question: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  required: PropTypes.bool.isRequired,
};

AnswerScale10.defaultProps = {
  low: "",
  middle: "",
  high: "",
  required: false,
  question: "",
};

export default AnswerScale10;
